import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import EventPage from './event/EventPage';
import './Melismes.scss';
import ProgramPage from './program/ProgramPage';
import ResourcePage from './resource/ResourcePage';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (

    <MainLayout enableAnalytics={false} scope={'melismes'} websiteLabel={"melismes.fr"}>
      <ProgramPage isActive={navigationContext.activeAppKey === 'program'} />
      <ResourcePage isActive={navigationContext.activeAppKey === 'resource'} />
      <EventPage isActive={navigationContext.activeAppKey === 'msevent'} />
    </MainLayout>
  );
}

export default Home;
